import React, { createContext, useState, useMemo } from "react";
import { LocaleProvider } from "@oursky/react-messageformat";
import enJson from "./translation/en.json";
import zhHantJson from "./translation/zhHant.json";
import { MessageJson, Locale } from "./types";
import { registerLocale } from "@ntpu/i18n-iso-countries";

const messageByLocale: { [key in Locale]: MessageJson } = {
  en: enJson,
  zhHant: zhHantJson,
};

interface LocalizationContextValue {
  setLocale: (locale: Locale) => void;
}

export const LocalizationContext = createContext<LocalizationContextValue>(
  null as any
);

const I18nProvider: React.FC = props => {
  const { children } = props;
  const [locale, setLocale] = useState(Locale.en);
  // register locale for country code translation
  registerLocale(require("@ntpu/i18n-iso-countries/langs/en.json"));
  registerLocale(require("@ntpu/i18n-iso-countries/langs/tw.json"));

  const localizationContextValue = useMemo(() => {
    return { setLocale };
  }, []);

  return (
    <LocalizationContext.Provider value={localizationContextValue}>
      <LocaleProvider locale={locale} messageByID={messageByLocale[locale]}>
        {children}
      </LocaleProvider>
    </LocalizationContext.Provider>
  );
};

export default I18nProvider;
